import { projects } from "../../../../utils/images"
export const projectsData = [
    {id : 1 , key : "desiDelight" , images : projects.desiDelight , techstack : "Wordpress + Css + Javascript" , link : "https://desiidelight.com/"},
    {id : 2 , key : "portfolio" , images : projects.portfolio , techstack : "React + Css + Firebase" , link : "https://suvam.xyz/"},
    {id : 3 , key : "reactAdminPanel" , images : projects.reactAdminPanel , techstack : "Html + Css + React" , link : "https://suvam2005.github.io/react-admin-panel/"}
]